import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'react-i18next'

import {
    TableHeadContainer,
    TableBody,
    TableHead,
    TableData,
    TableRow,
    RankTableData,
    LastTableData,
    LastTableHead,
    FirstTableData,
    RentMebutton
} from './DashboardTableStyles'

const TableContent = styled.table`
    width: 100%;
    

    @media screen and (max-width:950px){
        margin: 0;
        width: 950px;
    }
`
export const TableWrapper = styled.div`
    overflow: auto;
    overflow-x:scroll;
    
`


const RentalTables = ({posts, loading, rentals}) => {
    const { t } = useTranslation()  

  if(loading){
      return <h2>Loading....</h2>
  }  

  

  return (
    <>
    <TableWrapper>
    <TableContent id='table'>
        <TableHeadContainer>
        <TableRow>
            <TableHead>{t("page5.tableHead.tableHeadText1")}</TableHead>
            <TableHead>{t("page5.tableHead.tableHeadText2")}</TableHead>
            <TableHead>{t("page5.tableHead.tableHeadText3")}</TableHead>
            <TableHead>{t("page5.tableHead.tableHeadText4")}</TableHead>
            <TableHead>{t("page5.tableHead.tableHeadText5")}</TableHead>
            <LastTableHead>{t("page5.tableHead.tableHeadText6")}</LastTableHead>
        </TableRow>
        </TableHeadContainer>
        <TableBody>
        {
            posts.map(post => (
                <TableRow key= {post.id} >
                    <FirstTableData>
                        {post.wariableForRent}
                    </FirstTableData>
                    <RankTableData>{post.levelOrRank}</RankTableData>
                    <TableData>{post.multiplier}</TableData>
                    <TableData>{post.rentalPrice}</TableData>
                    <TableData>{post.rentalTerm}</TableData>
                    <LastTableData><RentMebutton id='rent' onClick={rentals}>{t("page5.rentMeButton")}</RentMebutton></LastTableData>
                </TableRow>
            ))
                
        }
    </TableBody>
    </TableContent>
    </TableWrapper>

    
    </>
  )
}

export default RentalTables